import { markRaw } from 'vue';
import { OnboardingFlow } from '@/types/onboarding.types';
import RiskAnalysisLaunchContent from '@/shared/components/onboarding/RiskAnalysisLaunchContent.vue';

export const RiskAnalysisOnboardingFlow: OnboardingFlow = {
  key: 'risk-analysis-route',
  steps: [
    {
      title: 'Overall Risk at a Glance',
      description:
        'See the customer’s overall risk rating and a short explanation of what factors led to it.',
      index: 1,
      targets: ['[data-testid="customer-risk-analysis-summary"]'],
    },
    {
      title: 'Spot Risk Across Documents',
      description:
        'Quickly assess how risky a customer’s documents are with a visual breakdown of high, medium, and low-risk files.',
      index: 2,
      targets: ['[data-testid="customer-risk-analysis-documents"]'],
    },
    {
      title: "See What's Driving the Risk",
      description:
        'Explore all customer-level insights, grouped by risk, to understand cross-document patterns and supporting evidence.',
      index: 3,
      targets: [
        '[data-testid="customer-risk-analysis-insights"] .expandable-item:first-child',
        '[data-testid="customer-risk-analysis-insights"] .header',
      ],
    },
    {
      title: 'Review Documents by Risk Level',
      description:
        'Find and review documents organized from high to low risk, so you can focus on what matters most.',
      index: 4,
      targets: [
        '[data-testid="customer-risk-analysis-documents-full-list"] .expandable-item:first-child',
        '[data-testid="customer-risk-analysis-documents-full-list"] .header',
      ],
    },
  ],
  activationRoutes: ['customer-risk-analysis'],
  launchScreenProps: {
    imageUrl: 'images/risk-analysis-onboarding_4x.webp',
    title: 'Risk Analysis, Reimagined',
    contentComponent: markRaw(RiskAnalysisLaunchContent),
  },
};
